import { useCallback, useEffect, useState } from 'react'
import {
  NEXT_PUBLIC_BUSINESS_EVENT_LOGGING_URL,
  NEXT_PUBLIC_BUSINESS_EVENT_LOGGING_API_KEY,
} from '~/lib/env'

type DataSend = {
  deduplication_id: string
  member_id: number | null
  device_token: string | null
  ga_client_id: string | undefined
  url: string
  client_timestamp: string
  event: string
  event_version: number
  payload: {
    wear_to_zozotown_event_uuid: string
    coordinate: {
      id: number
      member: {
        id: number
      }
      shop: { id: number } | null
    }
    coordinate_item: { id: number } | null
    item: { id: number } | null
  }
  debug: object
}

export type BusinessEventLoggingData = {
  loggedInMemberId: number | null
  timestamp: string
  coordinateId: number
  coordinateMemberId: number
  coordinateMemberShopId: number | null
  coordinateItemId: number | null
  itemId: number | null
}

/**
 * NOTE:
 * https://developers.google.com/analytics/devguides/collection/analyticsjs/cookies-user-id#cookie_flags
 * 上記が公式の取得方法っぽいがanalyticsjsを使用しておらず取得できないため、下記の様な実装にしている。
 */
const gaClientId = () => {
  return window.ga?.getAll?.()[0]?.get?.('clientId')
}

export const useBusinessEventLogging = () => {
  const [uuid, setUuid] = useState<string>('')

  useEffect(() => {
    setUuid(crypto.randomUUID())
  }, [])

  const sendLog = useCallback(
    (data: BusinessEventLoggingData) => {
      const sendData: DataSend = {
        deduplication_id: uuid,
        member_id: data.loggedInMemberId,
        device_token: null,
        ga_client_id: gaClientId(),
        url: location.href,
        client_timestamp: data.timestamp,
        event: 'click-item_buy_button-item',
        event_version: 1,
        payload: {
          wear_to_zozotown_event_uuid: uuid,
          coordinate: {
            id: data.coordinateId,
            member: {
              id: data.coordinateMemberId,
            },
            shop: data.coordinateMemberShopId
              ? { id: data.coordinateMemberShopId }
              : null,
          },
          coordinate_item: data.coordinateItemId
            ? { id: data.coordinateItemId }
            : null,
          item: data.itemId ? { id: data.itemId } : null,
        },
        debug: {},
      }
      fetch(NEXT_PUBLIC_BUSINESS_EVENT_LOGGING_URL, {
        method: 'POST',
        body: JSON.stringify(sendData),
        headers: {
          'content-type': 'application/json',
          'wear-logging-api-key': NEXT_PUBLIC_BUSINESS_EVENT_LOGGING_API_KEY,
        },
      })
      setUuid(crypto.randomUUID())
    },
    [uuid]
  )

  return { uuid, sendLog }
}
